let api

if (process.env.NODE_ENV === "development") {
    api = "http://localhost:5000/api"
} else {
    api = "https://wachatbot.vibhohcm.com/api"
}

export default api
